export enum StaffReportTabs {
  StaffReport = 0,
  AvailableStaffReport = 1,
}
